import {
  Button,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal as ModalAntd,
  Row,
  Spin,
  Upload,
  notification,
  Input,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { getAccessTokenApi } from '../../../../api/auth';
import {
  METHOD_GET,
  METHOD_PUT,
  ROL_FINANCIAL,
  ROL_ADMIN,
  ROL_LAYOUT,
  ROL_SUPPLIER,
} from '../../../../utils/constants';
import { fetchApi, fetchBlob } from '../../../../helpers/fetch';
import moment from 'moment';
import { API_URL_PAYMENTS } from '../../../../helpers/urls';
import {
  ExclamationCircleOutlined,
  FileAddOutlined,
  UploadOutlined,
} from '@ant-design/icons';
// import AddDocumentsPagoForm from '../Documents/AddDocumentsPagoForm';
import toBase64 from '../../../../utils/toBase64';
import useUser from '../../../../hooks/useUser';
import TextArea from 'antd/lib/input/TextArea';

const PaymentPurchaseOrder = (props) => {
  const [loadingImage, setLoadingImage] = useState(false);
  const [filesListImages, setFileListImages] = useState([]);
  const { person } = useUser();
  const { setModalIsVisible, poId, setReloadTable, type, response } = props;
  const [invoicePaymentForm] = Form.useForm();
  const [loadingForm, setLoadingForm] = useState(false);
  const token = getAccessTokenApi();
  const { confirm } = ModalAntd;

  useEffect(() => {
    //cargar documentos
    setLoadingForm(true);
    const config = {
      method: METHOD_GET,
      url: `SalesOrder/${poId}/getDocuments`,
      data: null,
      token,
      showNotificationError: true,
    };
    fetchApi(config)
      .then((response) => {
        if (response.statusCode === 200) {
          if (response.result.length > 0) {
            setFileListImages(
              response.result.map((paymentFile, index) => {
                return {
                  uid: index,
                  name: paymentFile.name,
                  extension: paymentFile.fileType,
                  stringFileContent: paymentFile.stringFileContent,
                  status: 'done',
                  url: paymentFile.fileLocation,
                  thumbUrl: paymentFile.fileLocation,
                  id: paymentFile.id,
                };
              })
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingForm(false);
      });
  }, [token, poId]);

  const extraImagesChange = (info) => {
    let fileList = [...info.fileList];
    if (fileList.length > 5) {
      notification['warn']({
        message: 'No puede subir más de 5 documentos',
      });
    }
    setFileListImages(fileList);
  };

  const propsUpload = {
    onRemove: async (file) => {
      if (file.response?.status === 'success') {
        // showDeleteConfirm(file);
        return false;
      } else {
        const index = filesListImages.indexOf(file);
        const newFileListImage = filesListImages.slice();
        newFileListImage.splice(index, 1);
        setFileListImages(newFileListImage);
        return true;
      }
    },
    beforeUpload: (file) => {
      return false;
    },

    onChange: extraImagesChange,
    //type === 'watch'

    showUploadList: {
      showDownloadIcon:
        props.type === 'watch' &&
        [ROL_ADMIN, ROL_LAYOUT, ROL_SUPPLIER, ROL_FINANCIAL].some((r) =>
          person.roles.includes(r)
        ),

      showRemoveIcon:
        props.type !== 'watch' &&
        [ROL_ADMIN, ROL_LAYOUT, ROL_FINANCIAL].some((r) =>
          person.roles.includes(r)
        ),
    },

    onDownload: (data) => {
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      const config = {
        method: METHOD_GET,
        url: `SalesOrder/${props.poId}/DownloadFile/${data.id}`,
        data: null,
        token,
        showNotificationError: false,
      };
      fetchBlob(config)
        .then((response) => {
          let url = window.URL.createObjectURL(response);
          a.href = url;
          a.download = data.name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onPreview: (data) => {
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      const config = {
        method: METHOD_GET,
        url: `SalesOrder/${props.poId}/DownloadFile/${data.id}`,
        data: null,
        token,
        showNotificationError: false,
      };
      fetchBlob(config)
        .then((response) => {
          let url = window.URL.createObjectURL(response);
          a.href = url;
          a.download = data.name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //onPreview: () => {},
  };

  const uploadExtraImageServe = () => {
    setLoadingImage(true);
    setLoadingForm(true);
    if (filesListImages.length > 0) {
      let imgs = [];
      filesListImages.forEach((img) => {
        if (img.status === 'done') {
          imgs.push({
            extension: img.extension,
            base64Promise: '',
            stringFileContent: img.stringFileContent,
            fileName: img.name,
            contentType: img.type,
          });
        } else {
          imgs.push({
            extension: img.originFileObj.type.split('/')[1],
            base64Promise: toBase64(img.originFileObj),
            stringFileContent: '',
            fileName: img.name,
            contentType: img.type,
          });
        }
      });

      Promise.all(imgs.map((img) => img.base64Promise)).then((values) => {
        values.forEach((value, index) => {
          if (value) {
            imgs[index].stringFileContent = value.split(',')[1];
          }
        });
      });
      const data = {
        documents: imgs,
      };
      setLoadingImage(false);
      setLoadingForm(false);
      return data;
    }
  };

  useEffect(() => {
    //edit or watch
    invoicePaymentForm.setFieldsValue({
      total: response.total,
    });
    if (response.paymentDate) {
      const date = moment.unix(response.paymentDate);
      const so = {
        paymentDate: date,
        total: response.total,
        bank: response.bank,
        account: response.account,
        observations: response.observations,
      };
      invoicePaymentForm.setFieldsValue(so);
    }
  }, [token, invoicePaymentForm, response]);

  const handleSavePOPayment = (values) => {
    var dataImg = uploadExtraImageServe();

    if (filesListImages.length === 0) {
      notification['error']({
        message: 'Debes agregar un documento',
      });
      setLoadingImage(false);
      setLoadingForm(false);
    } else {
      confirm({
        title: !response.paymentDate ? 'Guardar pago' : 'Editar pago',
        icon: <ExclamationCircleOutlined />,
        content: !response.paymentDate
          ? '¿Estás seguro que deseas guardar pago?'
          : '¿Estás seguro que deseas editar pago?',
        okText: 'Si',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          // return;
          addPaymentPurchaseOrder(values, dataImg);
        },
        onCancel() {},
      });
    }
  };
  const addPaymentPurchaseOrder = (values, dataImg) => {
    setLoadingForm(true);
    values['paymentDate'] = moment(values.paymentDate).unix();
    values['Documents'] = dataImg.documents;
    values['id'] = poId;
    const config = {
      method: METHOD_PUT,
      url: `SalesOrder/${poId}/pay`,
      data: values,
      token,
      showNotification: true,
    };
    fetchApi(config)
      .then((response) => {
        setLoadingForm(false);
        setModalIsVisible(false);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingForm(false);
        setReloadTable(true);
      });
  };
  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };
  return (
    <div>
      <Form
        name="add-payment"
        layout="vertical"
        form={invoicePaymentForm}
        onFinish={handleSavePOPayment}
      >
        <Spin spinning={loadingForm} tip="Cargando...">
          <Row gutter={16}>
            <Col xs={24} md={12} lg={12}>
              <Form.Item
                label="Fecha de pago:"
                name="paymentDate"
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingrese fecha de factura',
                  },
                ]}
              >
                <DatePicker
                  format={'DD/MM/YYYY'}
                  disabledDate={disabledDate}
                  disabled={type === 'watch'}
                  style={{ width: '100%' }}
                  // disabled={disableAllInputs}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <Form.Item label="Total a pagar:" name="total">
                <InputNumber
                  disabled
                  style={{ width: '100%' }}
                  min={1}
                  formatter={(value) =>
                    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} md={12} lg={12}>
              <Form.Item
                label="Banco:"
                name="bank"
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingrese banco',
                  },
                ]}
              >
                <Input disabled={type === 'watch'}></Input>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <Form.Item
                label="Cuenta:"
                name="account"
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingrese cuenta',
                  },
                ]}
              >
                <Input disabled={type === 'watch'}></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item label="Observaciones:" name="observations">
                <TextArea disabled={type === 'watch'}></TextArea>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item>
                <Upload
                  {...propsUpload}
                  // accept="image/png,image/jpg"
                  multiple
                  listType="picture"
                  fileList={filesListImages}
                  defaultFileList={filesListImages}
                >
                  {[ROL_ADMIN, ROL_LAYOUT, ROL_FINANCIAL].some((r) =>
                    person.roles.includes(r)
                  ) && (
                    <Button
                      style={{ width: 250, marginLeft: 0 }}
                      className="btn-download"
                      icon={<UploadOutlined />}
                      disabled={type === 'watch'}
                    >
                      Comprobante de pago
                    </Button>
                  )}
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Spin>

        <Row justify="end">
          <Col>
            <Form.Item>
              <Button
                className="btn-enviar"
                block
                disabled={type === 'watch'}
                htmlType="submit"
                icon={<FileAddOutlined />}
              >
                Guardar
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default PaymentPurchaseOrder;
